/* eslint-disable */
import { Type, FileText, Barcode, QrCode, Image as ImageIcon, Table, Minus, Square, Circle } from 'lucide-react';
import qrCodeImg from '../../Images/LabelGenerator/qrCode.jpg';
import barCodeImg from '../../Images/LabelGenerator/barCode.jpg';

export const MM_TO_PX = 3;

export const GRID_MAX_ROWS = 10;
export const GRID_MAX_COLS = 6;

const namingOfMachineType = {
	APP: 'App (Product)',
	MACHINE: 'Machine (Product)',
	ASSET: 'Asset',
	MRD: 'MRD',
	FMCG: 'FMCG (Secondary Packaging)',
};

const labelComponents = [
	{ label: 'Field', key: 'text', icon: <Type size={18} /> },
	{ label: 'Text Area', key: 'staticText', icon: <FileText size={18} /> },
	{ label: 'Barcode', key: 'barcode', icon: <Barcode size={18} /> },
	{ label: 'QR Code', key: 'qrCode', icon: <QrCode size={18} /> },
	{ label: 'Image', key: 'image', icon: <ImageIcon size={18} /> },
	{ label: 'Table', key: 'table', icon: <Table size={18} /> },
	{ label: 'Line', key: 'line', icon: <Minus size={18} /> },
	{ label: 'Rectangle', key: 'rectangle', icon: <Square size={18} /> },
	{ label: 'Circle', key: 'circle', icon: <Circle size={18} /> },
];

const possiblePlaceholderArray = {
	MACHINE: [
		'Client Name',
		'Product Name',
		'Manufacturing Timestamp',
		'Gross Weight',
		'Manufacturing Date',
		'Expiry Date',
		'Reprint',
		'QC Number',
		'Container Weight',
		'QR Code',
		'Batch Number',
		'Weight',
		'Variant Name',
		'Selling Price',
		'Temperature',
		'Maximum Retail Price',
		'Unit Sale Price',
		'Unit Sale Price (product unit)',
		'Carbs',
		'Fats',
		'Protein',
		'Calories',
		'Calcium',
		'Quantity',
		'Unit Price',
		'From Store',
		'To Store',
		'Store Name'
	],
	APP: [
		'Client Name',
		'Product Name',
		'Expiry Date',
		'QR Code',
		'QC Number',
		'Quantity',
		'Process Name',
		'Inward Date',
		'Manufacturing Date',
		'To Store',
		'From Store',	
		'Manufacturing Timestamp',
		'Gross Weight',
		'Reprint',
		'Container Weight',
		'Batch Number',
		'Weight',
		'Variant Name',
		'Selling Price',
		'Temperature',
		'Maximum Retail Price',
		'Unit Sale Price',
		'Unit Sale Price (product unit)',
		'Thawing Date',
		'Carbs',
		'Fats',
		'Protein',
		'Calories',
		'Calcium',
		'Unit Price',
		'Store Name'
	],
	ASSET: [
		'Client Name',
		'QR Code',
		'ID',
		'From Store',
		'PoID',
		'Asset Type',
		'Scheduled At',
		'To Store',
	],
	MRD: [
		'Client Name',
		'Product Name',
		'Expiry Date',
		'QR Code',
		'Quantity',
		'Inward Date',
		'Manufacturing Date',
		'Thawing Date',
		'Thawing Timestamp',
		'Variant Name',
	],
	FMCG: [
		'Client Name',
		'Product Name',
		'Expiry Date',
		'QR Code',
		'QC Number',
		'Quantity',
		'Inward Date',
		'Gross Weight',
		'Net Weight',
		'Ideal Net Weight',
		'Ideal Gross Weight',
	],
};

// ZPL printer ke built-in fonts. value = ZPL font code (^A<code>). Font 0 scalable hai
// (kisi bhi size pe smooth); A/B/D/F/G bitmap fonts (fixed shape, scale par blocky);
// E = OCR-B, H = OCR-A. CSS fonts (Arial/Times) printer me hote hi nahi, isliye hata diye.
export const fontFamilyOptions = [
	{ label: 'Default (scalable)', value: '0' },
	{ label: 'Font A', value: 'A' },
	{ label: 'Font B', value: 'B' },
	{ label: 'Font D', value: 'D' },
	{ label: 'Font F', value: 'F' },
	{ label: 'Font G', value: 'G' },
	{ label: 'OCR-B (E)', value: 'E' },
	{ label: 'OCR-A (H)', value: 'H' },
];

// printer ke ^GB sirf solid line karta hai (dashed/dotted/double print me nahi aate),
// isliye dropdown me sirf solid + none rakhte hain.
export const lineStyleOptions = [
	{ label: 'Solid', value: 'solid' },
	{ label: 'None', value: 'none' },
];

export const DENSITY_OPTIONS = [
	{ label: '152 dpi (6 dpmm)', value: 6 },
	{ label: '203 dpi (8 dpmm)', value: 8 },
	{ label: '300 dpi (12 dpmm)', value: 12 },
	{ label: '600 dpi (24 dpmm)', value: 24 },
];

// Label ke common preset sizes (mm me). 'Custom' option dropdown me alag se add hota hai
// (LabelGenerator.jsx me) jisse user manually width/height de sake.
export const LABEL_SIZE_PRESETS = [
	{ label: '25 x 15 mm', width: 25, height: 15 },
	{ label: '38 x 25 mm', width: 38, height: 25 },
	{ label: '50 x 25 mm', width: 50, height: 25 },
	{ label: '50 x 30 mm', width: 50, height: 30 },
	{ label: '60 x 40 mm', width: 60, height: 40 },
	{ label: '75 x 50 mm', width: 75, height: 50 },
	{ label: '100 x 50 mm', width: 100, height: 50 },
	{ label: '100 x 60 mm', width: 100, height: 60 },
	{ label: '100 x 150 mm (4x6)', width: 100, height: 150 },
];

export const muiSelectSx = {
	height: 36,
	fontSize: 13,
	backgroundColor: '#fff',
	'& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' },
	'&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9ca3af' },
	'& .MuiSelect-select': { display: 'flex', alignItems: 'center', py: 0, minHeight: 'unset' },
};

export const DEFAULT_TOOL_STATE = {
	borderColor: '#000000',
	thickness: 1,
	borderStyle: 'none',
	lineStyle: 'none',
	fontFamily: '0',
	rotate: 0,
	borderRadius: 0,
	fontSize: 16,
	lineHeight: 1.2,
	textAlign: 'left',
	isBold: false,
	isItalic: false,
	isUnderline: false,
	isHighlight: false,
	fill: false,
};

export const withBorderDefaults = (prev, key, value) => {
	const next = { ...prev, [key]: value };
	// thickness / borderColor / borderRadius me se koi bhi set ho to border ON maan lo
	// (warna borderStyle 'none' rehne par editor me dashed placeholder dikhta hai par
	// ZPL me border generate nahi hota -> "border laag nahi raha" wala issue).
	if ((key === 'thickness' || key === 'borderColor' || key === 'borderRadius')
		&& value && value !== 'none'
		&& (!prev.borderStyle || prev.borderStyle === 'none')) {
		next.borderStyle = 'solid';
		if (!prev.borderColor || prev.borderColor === 'none') next.borderColor = next.borderColor || '#000000';
	}
	return next;
};

const labelCardActiveStyles = ['border', 'thickness', 'borderStyle'];
const lineComponentActiveStyles = ['lineStyle', 'thickness', 'rotate'];
const textComponentActiveStyles = ['borderStyle', 'thickness', 'borderRadius', 'fontFamily', 'fontSize', 'lineHeight', 'textAlign', 'isBold', 'isItalic', 'isUnderline', 'isHighlight', 'rotate'];
const imageComponentActiveStyles = ['borderStyle', 'thickness', 'borderRadius', 'rotate'];
// rectangle: outline + corner radius; circle: outline only (radius is always round)
const rectangleActiveStyles = ['borderStyle', 'thickness', 'borderColor', 'borderRadius', 'fill', 'rotate'];
const circleActiveStyles = ['borderStyle', 'thickness', 'borderColor', 'fill', 'rotate'];
// table cell ke liye text jaisa hi, par bina 'rotate' (cells rotate nahi hote)
export const tableCellActiveStyles = textComponentActiveStyles.filter((s) => s !== 'rotate');

export const ActiveStyle = {
	'label': labelCardActiveStyles,
	'line': lineComponentActiveStyles,
	'text': textComponentActiveStyles,
	'staticText': textComponentActiveStyles,
	'qrCode': imageComponentActiveStyles,
	'barcode': imageComponentActiveStyles,
	'image': imageComponentActiveStyles,
	'table': ['borderStyle', 'thickness', 'borderColor'],
	'rectangle': rectangleActiveStyles,
	'circle': circleActiveStyles,
};

export const renderLinePreview = (value, width) => (
	value === 'none'
		? <span className='text-[13px] text-gray-400'>None</span>
		: (
			<span
				className='inline-block align-middle'
				style={{ width, borderTop: `3px ${value} #1f2937` }}
			/>
		)
);

const OLD_REM_TO_PX = ((12.25 * 25.4) / 96) * 3;
const OLD_POS_TO_PX = (1.65 / 8) * 3;

const remToPx = (val, fallback) => {
	if (typeof val === 'number') return val;
	if (typeof val === 'string') {
		const n = parseFloat(val);
		if (!Number.isNaN(n)) return Math.round(n * OLD_REM_TO_PX);
	}
	return fallback;
};

// migrated single-line text (input) clip ho jaata tha agar box content se chhota ho.
// content + fontSize se minimum width estimate karke ensure karte hain ki text cut na ho.
const fitTextWidth = (text, fontSize, base) => {
	const est = Math.ceil(String(text || '').length * (Number(fontSize) || 16) * 0.62) + 14;
	return Math.max(base || 0, est);
};

const isOldComponent = (c) => !!c && c.type !== undefined && c.name === undefined;

const migrateOldComponent = (c) => {
	const base = {
		id: c.id ?? Date.now(),
		position: {
			x: Math.round((c.position?.x ?? 0) * OLD_POS_TO_PX),
			y: Math.round((c.position?.y ?? 0) * OLD_POS_TO_PX),
		},
		rotate: 0,
		borderRadius: 0,
		borderStyle: 'none',
		borderColor: '#000000',
		thickness: 1,
		selected: false,
	};
	switch (c.type) {
		case 'text': {
			const content = c.text?.placeHolderName ?? c.text?.placeholderText ?? 'Text';
			const fontSize = c.text?.fontSize ?? 16;
			return {
				...base,
				name: 'text',
				content,
				placeholder: c.text?.placeHolderName ?? '',
				fontSize,
				lineHeight: 1.2,
				fontFamily: '0',
				// width ko content ke hisaab se fit karo taaki migrate hone par text cut na ho
				size: { width: fitTextWidth(content, fontSize, remToPx(c.text?.width, 120)), height: remToPx(c.text?.height, 28) },
				color: '#000000',
				isBold: false,
				isItalic: false,
				isUnderline: false,
			};
		}
		case 'staticText':
			return {
				...base,
				name: 'staticText',
				content: c.staticText?.text ?? '',
				fontSize: c.staticText?.fontSize ?? 14,
				lineHeight: 1.2,
				fontFamily: '0',
				size: { width: remToPx(c.staticText?.width, 160), height: remToPx(c.staticText?.height, 60) },
				color: '#000000',
				isBold: false,
				isItalic: false,
				isUnderline: false,
			};
		case 'qrCode':
			return {
				...base,
				name: 'qrCode',
				src: qrCodeImg,
				size: { width: remToPx(c.qrCode?.width, 70), height: remToPx(c.qrCode?.height, 70) },
			};
		case 'barCode':
			return {
				...base,
				name: 'barcode',
				src: barCodeImg,
				size: { width: remToPx(c.barCode?.width, 140), height: remToPx(c.barCode?.height, 50) },
			};
		case 'image':
			return {
				...base,
				name: 'image',
				src: c.image?.imageURL ?? '',
				file: null,
				size: { width: remToPx(c.image?.width, 160), height: remToPx(c.image?.height, 100) },
			};
		default:
			return null;
	}
};

export const migrateLabelComponents = (components) => {
	if (!Array.isArray(components)) return [];
	return components.map((c) => (isOldComponent(c) ? migrateOldComponent(c) : c)).filter(Boolean);
};

const labelGeneratorConfig = {
	namingOfMachineType,
	labelComponents,
	possiblePlaceholderArray,
};

export default labelGeneratorConfig;
